import { ElMessageBox, type Action } from 'element-plus';

export function useMessageBox() {
  /** 呼叫toast */
  const openMessageBox = (
    message: string,
    confirmButtonText: string,
    callback: () => void
  ) => {
    ElMessageBox.alert(message, '您重複登入，系統已自動登出。', {
      confirmButtonText: confirmButtonText,
      callback: callback
    });
  };

  return {
    openMessageBox
  };
}
